(ns bp-clients.tv-app.nav.views.register-page
  "Namespace for register page view"
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.nav.events :as nav-events]
   [bp-clients.tv-app.nav.views.loading :refer [loading]]
   [bp-clients.tv-app.router :as router]
   [bp-clients.tv-app.utils.os :as os-utils]
   [bp-libs.design-system.components.buttons :refer [Button]]
   [bp-libs.design-system.components.icons :refer [bp-original]]
   [bp-libs.design-system.components.qr-code :refer [qr-code-component]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn register-page []
  (let [main-focus-ref (createRef)
        loading?       (r/atom false)
        register-url   (case os-utils/device
                         "tizen" "https://brasilparalelo.com.br/samsung"
                         "webos" "https://brasilparalelo.com.br/lg"
                         "go.brasilparalelo.com.br/campaign/tech-plataforma")]
    (fn []
      (r/create-class {:component-did-mount (fn [_react-component]
                                              (when-let [main-button main-focus-ref.current]
                                                (.focus main-button)))
                       :reagent-render      (fn [_props]
                                              (if @loading?
                                                [loading]

                                                [:main {:class "relative min-h-screen w-full dark-green-gradient overflow-hidden overscroll-contain"}
                                                 [:div {:class "py-[3em] flex flex-col text-white space-y-4"}
                                                  [:div {:class "flex flex-col items-center w-full space-y-6"}
                                                   [:div {:class "flex items-center justify-center w-full"}
                                                    [bp-original {:width "5%" :height "5%"}]]
                                                   [:div {:class "uppercase text-2xl"} "Assine agora"]]
                                                  [:div {:class "flex w-full items-start justify-center space-x-16"}
                                                   [:div {:class "w-[40vw] space-y-6 flex flex-col"
                                                          :style {:width "40vw"}}
                                                    [:div {:class "text-gray-400 text-3xl font-bold"} "Passo 1"]
                                                    [:div {:class "font-bold text-5xl"} "Escolha seu plano"]
                                                    [:div {:class "text-2xl"} "Escaneie o QR code ou acesse o endereço embaixo em um computador ou dispositivo móvel para continuar. Siga todos os passos indicados."]
                                                    [:div {:class "flex items-center"}
                                                     [qr-code-component register-url false]
                                                     [:div {:class "font-bold px-8 py-3.5 bg-black text-2xl w-full text-center rounded-lg items-center ml-4 h-24 break-all"}
                                                      register-url]]]
                                                   [:div {:class "w-[40vw] space-y-6 flex flex-col"}
                                                    [:div {:class "text-gray-400 text-3xl font-bold"} "Passo 2"]
                                                    [:div {:class "font-bold text-5xl"} "Faça login na TV"]
                                                    [:div {:class "text-2xl"}
                                                     "Após a confirmação da assinatura, faça login utilizando a  mesma conta que você utilizou para realizar a assinatura."]]]
                                                  [:div {:class "flex items-center justify-center text-lg"}
                                                   [Button {:color         "gray"
                                                            :tab-index     10
                                                            :react-ref     main-focus-ref
                                                            :extra-classes ["px-4 outline-none text-2xl"]
                                                            :on-click      #(do (reset! loading? true)
                                                                                (rf/dispatch [::nav-events/navigate ::router/login]))}
                                                    "Fazer login"]]]]))}))))
